/**
 * Route-param identifiers for the player-kanban (Pipeline) screen.
 *
 * The route key namespaces the sessionStorage mirror in
 * `utils/persistedRouteParams`, so it MUST be identical on the write side
 * (`useBoardSelectionPersistence`) and the read side
 * (`useBoardDeepLink`) — a mismatch stores under one key and
 * reads from another, silently disabling reload persistence. It lives here
 * rather than being duplicated at both call sites so the two can never drift.
 * @module features/player-kanban/constants/routeParams
 */

/** sessionStorage namespace for params owned by the player-kanban route. */
export const PLAYER_KANBAN_ROUTE_KEY = "player-kanban";

/** Query param carrying the active board id (`/player-kanban?boardId=<uuid>`). */
export const BOARD_ID_PARAM = "boardId";

/**
 * Query param carrying a player whose preview drawer should auto-open on
 * arrival (`/player-kanban?boardId=<uuid>&playerId=<uuid>`, SE-7121). Emitted
 * by the backend's pipeline feed clickthroughs alongside `boardId`; INBOUND
 * only, same as `boardId` — nothing writes it back to the URL.
 */
export const PLAYER_ID_PARAM = "playerId";
